{
  "//": "HKSCA — 品牌唯一設定來源（decisions/010 Phase A）。⚠️ 換協會只需改呢個檔；唔准喺其他地方硬編碼品牌。",
  "//slug": "用喺：合成 email 網域、部署命名參考（唔會自動改 Pages／D1 名）",
  "slug": "hksca",

  "nameZhHk": "香港智慧餐飲協會",
  "nameZhCn": "香港智慧餐饮协会",
  "nameEn": "Hong Kong Smart Catering Association",

  "//appName": "App 顯示名（會員端）",
  "appNameZhHk": "HKSCA 會員系統",
  "appNameZhCn": "HKSCA 会员系统",
  "appNameEn": "HKSCA Members",
  "//shortName": "PWA 主畫面圖示下面嘅短名（建議 ≤ 12 字元）",
  "shortName": "HKSCA",

  "//committeeAppName": "第 2 個 PWA（理事會端）顯示名",
  "committeeAppNameZhHk": "HKSCA 理事會",
  "committeeAppNameZhCn": "HKSCA 理事会",
  "committeeAppNameEn": "HKSCA Committee",

  "//supportEmail": "法務頁／對外聯絡電郵",
  "supportEmail": "simon@coeldery85.org",
  "//waNumber": "WhatsApp 登記號碼（國際格式、無 + ；VITE_WA_NUMBER 由呢度讀）",
  "waNumber": "15556573474",
  "//mailDomain": "WhatsApp 合成 email 網域（wa-<電話>@<mailDomain>；wrangler vars 要一致）",
  "mailDomain": "hksca.local",
  "//memberNoPrefix": "會員編號前綴（例 HKSCA-2026-0001）。⚠️ 改咗只影響新編號，舊資料唔動",
  "memberNoPrefix": "HKSCA",

  "//defaultLocale": "預設語言（zh-HK | zh-CN | en）",
  "defaultLocale": "zh-HK",

  "//colors": "品牌色 —— 執行時套入 CSS var（tokens.css 只放 fallback，唔准喺 feature 寫 hex）",
  "colors": {
    "primary": "#1b2450",
    "primaryStrong": "#121936",
    "primarySoft": "#e6e9f5",
    "accent": "#ef8f74",
    "accentStrong": "#e2745a",
    "accentSoft": "#fdece6",
    "brandGradTo": "#7b6fd0",
    "bg": "#f5f6fb",
    "bgTint": "#eceef7",
    "cardTop": "#ffffff"
  },

  "//logos": "logo 檔位置（放喺 public/）；換品牌就換呢三個 PNG",
  "logos": {
    "mark": "/brand-mark.png",
    "horizontal": "/brand-horizontal.png",
    "square": "/brand-square.png"
  },

  "//themeColor": "PWA manifest 嘅 theme_color／background_color",
  "themeColor": "#1b2450",
  "backgroundColor": "#f5f6fb"
}
